import React, { useState, useContext, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ThemeContext } from "../contexts/ThemeContext";
import FishIcon from "./FishIcon";

function NavBar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    function scrollHandler() {
      setScrolled(window.scrollY >= 12);
    }
    window.addEventListener("scroll", scrollHandler);
    scrollHandler();
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const close = () => setOpen(false);

  return (
    <header className={scrolled ? "site-nav site-nav--scrolled" : "site-nav"}>
      <div className="nav-inner">
        <Link to="/" className="nav-wordmark" onClick={close}>
          <FishIcon className="nav-mark" />
          <span>Nicole Luo</span>
        </Link>
        <button
          type="button"
          className={open ? "nav-toggle nav-toggle--open" : "nav-toggle"}
          aria-expanded={open}
          aria-label="Menu"
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
        </button>
        <nav className={open ? "nav-links nav-links--open" : "nav-links"}>
          <NavLink to="/experiences" className="nav-item-link" onClick={close}>
            Experience
          </NavLink>
          <NavLink to="/project" className="nav-item-link" onClick={close}>
            Projects
          </NavLink>
          <NavLink to="/photos" className="nav-item-link" onClick={close}>
            Photos
          </NavLink>
          <button
            type="button"
            onClick={toggleTheme}
            className="theme-toggle"
            aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
          >
            {theme === "dark" ? "Light" : "Dark"}
          </button>
        </nav>
      </div>
    </header>
  );
}

export default NavBar;
